<!-- TODO - No dialog title? -->
<mat-dialog-content class="items-list">
    <busy-indicator *ngIf="!isLoaded" [big]="true" class="mt10"></busy-indicator>

    <ng-container *ngIf="isLoaded">
        <div *ngIf="!HasResults" fxLayout="row" fxLayoutAlign="center center">
            No Results
        </div>

        <div *ngIf="HasResults">
            <ng-container *ngFor="let item of criteria.SearchResult">
                <info-card [item]="item" [headerComponent]="headerComponent" [detailComponent]="detailComponent" [expand]="criteria.SearchResult.length == 1" [expandable]="true">
                </info-card>
            </ng-container>
        </div>
    </ng-container>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button color="primary" mat-dialog-close telemetry="Submission-CardSearchClose">
        Close
    </button>
</mat-dialog-actions>